import { Link } from 'react-router-dom';
import { styled, Typography } from '@bluedolphin/ui';

export const FooterLink = styled(Link)({
    color: 'rgba(0, 71, 187, 1)',
    textDecoration: 'none',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20.02px',
    letterSpacing: '0.17px',
});

export const SectionTitle = styled(Typography)({
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '32px',
    letterspacing: '0.15px',
    textAlign: 'left',
    color: 'rgba(29, 31, 36, 1)',
});
